module.exports = __webpack_public_path__ + "img/Icon_CompanyCulture.d63af672.png";